import {Iso8601} from '@hconnect/common/types'
import {Moment} from 'moment-timezone'

/**
 * Base manual KPI structure shared between DTO and domain types
 */
export type BaseManualKpi = {
  name: string
  unit: string
  processStage: string
  actualValue?: number
  plannedValue?: number
  delta?: number
}

/**
 * Manual KPI Data Transfer Object (from API)
 */
export type ManualKpiDto = BaseManualKpi & {
  id: string
  timestamp: Iso8601
  createdAt: Iso8601
  updatedAt: Iso8601
  concurrencyStamp: string
  resolution: ManualKpiResolution
}

/**
 * Manual KPI domain type (with Moment dates)
 */
export type ManualKpi = BaseManualKpi & {
  id: string
  timestamp: Moment
  createdAt: Moment
  updatedAt: Moment
  concurrencyStamp: string
  resolution: ManualKpiResolution
}

/**
 * Manual KPI for update operations
 */
export type ManualKpiToUpdate = BaseManualKpi & {
  id?: string // if id is supplied then its update of existing entity
  concurrencyStamp?: string
}

/**
 * Manual KPI resolution enum
 */
export enum ManualKpiResolution {
  Daily = 'Daily',
  PerShift = 'perShift'
}

/**
 * Manual KPI suggestion for autocomplete
 */
export type ManualKpiSuggestion = {
  name: string
  unit: string
  processStage: string
}
